export default __webpack_public_path__ + "static/media/wedding_pic1.99a31f09.jpg";